/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ConfirmLicensingAccountSignUpError = "ALREADYCONFIRMED" | "CODEEXPIRED" | "INVALIDINPUT" | "UNKNOWNERROR" | "USERNOTFOUND" | "%future added value";
export type ConfirmLicensingSignUpInput = {
    code: string;
    email: string;
};
export type confirmSignUpMutationVariables = {
    input: ConfirmLicensingSignUpInput;
};
export type confirmSignUpMutationResponse = {
    readonly confirmLicensingSignUp: {
        readonly wasSuccessful: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly errorCode: ConfirmLicensingAccountSignUpError;
            readonly message: string;
        } | null> | null;
    } | null;
};
export type confirmSignUpMutation = {
    readonly response: confirmSignUpMutationResponse;
    readonly variables: confirmSignUpMutationVariables;
};



/*
mutation confirmSignUpMutation(
  $input: ConfirmLicensingSignUpInput!
) {
  confirmLicensingSignUp(input: $input) {
    wasSuccessful
    errors {
      errorCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfirmLicensingAccountSignUp",
            "kind": "LinkedField",
            "name": "confirmLicensingSignUp",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wasSuccessful",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailedErrorOfConfirmLicensingAccountSignUp",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "errorCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "confirmSignUpMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "confirmSignUpMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "b148f67e3d0dc82975c1d4d90c06d609",
            "id": null,
            "metadata": {},
            "name": "confirmSignUpMutation",
            "operationKind": "mutation",
            "text": "mutation confirmSignUpMutation(\n  $input: ConfirmLicensingSignUpInput!\n) {\n  confirmLicensingSignUp(input: $input) {\n    wasSuccessful\n    errors {\n      errorCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '06edee333f6eb4c8b929eb7be39f7243';
export default node;
